import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const SendEmailToLeadModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, emailToLeadMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    email, onEmailChange, emailError, setEmailError,
    directorName, onDirectorNameChange, directorNameError, setDirectorNameError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Send Email To Lead'
        buttonLabel='Send'
        cancelLabel='Cancel'
        isOpen={emailToLeadMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='email' label='Email'
            maxLength={40} required={true}
            value={email} onChange={onEmailChange}
            error={emailError} setError={setEmailError}
        />
        <InputTextSF type='text' name='directorName' label='Director Name'
            maxLength={40} required={true}
            value={directorName} onChange={onDirectorNameChange}
            error={directorNameError} setError={setDirectorNameError}
        />
    </ModalFormUI>

export default SendEmailToLeadModalUI
